import ky from 'ky';

export const authClient = ky.create({
    prefixUrl: import.meta.env.VITE_BACKEND_URL + '/auth',
    credentials: 'include',
});
